import { Box } from '@mui/material';
import { sharedContentStyles } from './richTextEditorStyles';
import classNames from 'classnames';
import { Placeholder } from './Placeholder';

export const RichTextEditorViewer = ({
  richText,
  className,
  onClick,
  placeholder,
}: {
  richText?: string;
  className?: string;
  onClick?: () => void;
  placeholder?: string;
}) => {
  const showPlaceholder = !richText && placeholder;

  const maybeRenderPlaceholder = showPlaceholder ? <Placeholder placeholder={placeholder} /> : null;
  const maybeRenderRichText = richText ? { __html: richText } : undefined;

  return (
    <Box
      className={classNames(className, 'rich-text-editor-viewer')}
      sx={{
        width: '100%',
        height: '100%',
        padding: '8px',
        wordBreak: 'break-word',
        '&.rich-text-editor-viewer': sharedContentStyles,
        cursor: 'move',
      }}
      dangerouslySetInnerHTML={maybeRenderRichText}
      onClick={onClick}
    >
      {maybeRenderPlaceholder}
    </Box>
  );
};
